class LancamentoList {
    get revisaoHistoricoQuery() {
        return `revisaoHistorico {
                    status
                    insertedAt
                    usuario { nome }
                }`
    }

    static get $inject() {
        return ['api', 'gql', '$scope', '$uibModal']
    }

    constructor(api, gql, scope, modal) {
        this.api = api
        this.gql = gql
        this.apply = (fn) => scope.$apply(fn)
        this.modal = modal

        this.order = { sortField: 'EMISSAO', sortOrder: 'DESC' }
        this.filter = {}
        this.perPage = 10

        this.nfes = []
        this.statusRevisao = ['REGULARIZAR', 'PROCESSO', 'CONCLUIDA']
    }

    $onInit() {
        this.fetchNfesEmissaoExternaCount()
    }

    $onChanges({ filter, empresaId }) {
        this.currentPage = 1

        if (filter && filter.currentValue) {
            this.filter = filter.currentValue
        }

        const promises = [this.loadEmpresaUsuario(), this.loadLancamentos({})]

        if (empresaId && empresaId.currentValue) {
            promises.push(this.checkIfPodeEmitirExtratoIcms(empresaId.currentValue))
        }

        this.loadingPromise = Promise
            .all(promises)
            .then(() => {
                if (empresaId) {
                    this.createOrReplaceSubscriptions()
                }
            })
            .finally(() => this.apply())
    }

    $onDestroy() {
        this.tearDownSubscriptions()
    }

    pageChange(page) {
        this.loadingPromise = this.loadLancamentos(page)
    }

    sortBy(field) {
        let { sortField, sortOrder } = this.order

        if (field === sortField) {
            sortOrder = sortOrder === 'DESC' ? 'ASC' : 'DESC'
        } else {
            sortField = field
            sortOrder = 'ASC'
        }

        this.order = { sortField, sortOrder }
    }

    getSortingClass(field) {
        let { sortField, sortOrder } = this.order

        if (field !== sortField)
            return 'fa-unsorted'
        else
            return `fa-sort-${sortOrder.toLowerCase()}`
    }

    getRevisaoIcon(status) {
        switch (status) {
            case 'regularizar': return 'fa-question-circle text-warning'
            case 'processo': return 'fa-exclamation-circle text-danger'
            case 'concluida': return 'fa-check-circle text-success'
        }
    }

    getStatusDescricao(status) {
        switch (status) {
            case 'regularizar': return 'Lançamento a regularizar'
            case 'processo': return 'Lançamento em processo fiscal'
            case 'concluida': return 'Revisão concluída'
        }
    }

    showDetails(nfe, lancamento) {
        this.modal.open({
            backdrop: 'static',
            size: 'lg',
            component: 'lancamentoModal',
            resolve: {
                nfe: () => nfe,
                lancamento: () => lancamento
            }
        })
    }

    checkIfPodeEmitirExtratoIcms(empresaId) {
        return this.api
            .get(`/eficiencia-fiscal/extrato-nfe-icms?contrato=${empresaId}&q=check-only`)
            .then((permissao) => this.podeEmitirExtratoIcms = permissao.data.success)
            .catch(() => this.podeEmitirExtratoIcms = false)
    }

    emitirExtratoIcms(nfe) {
        if (this.empresa.icms) {
            let url = `/api/eficiencia-fiscal/extrato-nfe-icms?nfe=${nfe.id}&reauditar=false&q=emitir`
            cbk.download(url)
        } else {
            Confirm.warning(
                'Atenção',
                'A funcionalidade exige que a empresa possua parâmetros de ICMS configurados. Deseja configurá-los agora?',
                {
                    'Não': angular.noop,
                    'Sim': () => {
                        this.modal
                            .open({
                                component: 'configuracaoIcmsModal',
                                size: 'lg',
                                keyboard: 'static',
                                resolve: {
                                    empresaId: () => this.empresa.id
                                }
                            })
                            .result.then(result => {
                                if (result) {
                                    this.empresa.icms = result
                                }
                            })
                    }
                }
            )
        }
    }

    emitirDanfe(nfe) {
        this.downloadOperation(this.fetchTokenNfe('DownloadNfeDa', nfe.chave, 'danfe'))
    }

    iniciarSac(nfe) {
        let razaoSocial = encodeURIComponent(this.empresa.razaoSocial)
        let nomeUsuario = encodeURIComponent(this.usuario.nome)

        let url = `https://sac.eficienciafiscal.com.br/sac-servico-de-atendimento-ao-consumidor/
            ?sac-razao-social-empresa=${razaoSocial}&sac-cnpj-empresa=${this.empresa.cnpj}
            &your-name=${nomeUsuario}&your-email=${this.usuario.email}&nfe=${nfe.numero}`

        window.open(url)
    }

    exibirHistoricoRevisao(nfe) {
        this.modal.open({
            backdrop: 'static',
            size: 'md',
            component: 'lancamentoRevisaoHistoricoModal',
            resolve: {
                nfe: () => nfe
            }
        })
    }

    exibirComentarios(nfe) {
        this.modal.open({
            backdrop: 'static',
            size: 'md',
            component: 'nfeComentariosModal',
            resolve: {
                nfe: () => nfe,
                origem: () => "AUDITORIA_INTEGRADA_ICMS",
                empresaId: () => this.contratoId
            }
        })
    }

    async revisarNfe(nfe, status) {
        const query = gql`
            mutation RevisarNfeAII($empresaId: String!, $filialId: Int!, $nfeId: Int!, $status: RevisaoStatus!) {
                empresa(id: $empresaId) {
                    revisao: revisarNfeAuditoriaIntegrada(id: $nfeId, status: $status, filialId: $filialId) {
                        id
                        status
                        insertedAt
                        usuario {
                            id
                            nome
                        }
                        nfe { ${this.revisaoHistoricoQuery} }
                    }
                }
            }
        `
        const variables = { empresaId: this.contratoId.toString(), filialId: this.empresaId, nfeId: parseInt(nfe.id), status }
        const { empresa: { revisao } } = await this.gql.mutate(query, variables)

        if (revisao.id) {
            this.apply(() => {
                nfe.revisao = revisao
                nfe.revisaoHistorico = revisao.nfe.revisaoHistorico
            })
        }
    }

    async removerRevisaoNfe(nfe) {
        const query = gql`
            mutation RemoverRevisaoNfeAII($empresaId: String!, $filialId: Int!, $nfeId: Int!) {
                empresa(id: $empresaId) {
                    revisao: removerRevisaoNfeAuditoriaIntegrada(id: $nfeId, filialId: $filialId) {
                        id
                        nfe { ${this.revisaoHistoricoQuery} }
                    }
                }
            }
        `

        const { empresa: { revisao } } = await this.gql.mutate(query, { empresaId: this.contratoId.toString(), filialId: this.empresaId, nfeId: parseInt(nfe.id) })

        if (revisao.id) {
            this.apply(() => {
                nfe.revisao = undefined
                nfe.revisaoHistorico = revisao.nfe.revisaoHistorico
            })
        }
    }

    async downloadOperation(tokenPromise) {
        let tab = cbk.initDownloadTab();
        let token = await tokenPromise
        cbk.download(`/api/resume-operation/${token}`, tab)
    }

    async fetchTokenNfe(operation, chave, format) {
        const query = gql`
            query ${operation}($empresaId: Int!, $filter: NfeFilter!) {
                empresa: filial(id: $empresaId) {
                    id
                    nfe(filter: $filter) {
                        ${format} { token }
                    }
                }
            }
        `

        let { empresa: { nfe } } =
            await this.gql.query(query, { empresaId: this.empresaId, filter: { chave } })

        return nfe[format]['token']
    }

    async loadEmpresaUsuario() {
        if (!this.empresa || !this.usuario) {
            const query = gql`
                query EmpresaAndUsuario($empresaId: Int!) {
                    empresa: filial(id: $empresaId) {
                        id
                        razaoSocial
                        cnpj
                        icms {
                            id
                        }
                    }
                    usuario: usuarioAtual {
                        id
                        nome
                        email
                    }
                }
            `

            const { empresa, usuario } = await this.gql.query(query, { empresaId: this.empresaId })

            this.empresa = empresa
            this.usuario = usuario
        }
    }

    async loadLancamentos(page) {
        const query = gql`
            query LancamentosAII($empresaId: Int!, $nfeFilter: NfeFilter!, $lancamentoFilter: LancamentoFilter!, $after: String, $before: String) {
                empresa: filial(id: $empresaId) {
                    id
                    nfesPage(filter: $nfeFilter, after: $after, before: $before, limit: ${this.perPage}) {
                        after
                        before
                        nfes: entries {
                            ... on Nfe {
                                id
                                chave
                                numero
                                emissao
                                valor
                                emitente {
                                    id
                                    nome
                                    cpfCnpj
                                    uf
                                }
                                revisao {
                                    id
                                    status
                                    insertedAt
                                }
                                ${this.revisaoHistoricoQuery}
                                discussao {
                                    id
                                    comentarios {
                                        id
                                        texto
                                        origem
                                        insertedAt
                                        usuario { nome }
                                    }
                                }
                                lancamentos(filter: $lancamentoFilter) {
                                    id
                                    entrada
                                    valorTotalItem
                                    freteTipo
                                    freteNumero
                                    freteValor
                                    produto
                                    percentual
                                    valorAgregado
                                    baseCalculo
                                    aliquota
                                    debito
                                    credito
                                    icmsRecolher
                                    guiaResumo
                                    extrato {
                                        id
                                        numero
                                        receita
                                    }
                                }
                                lancamentosCount
                            }
                        }
                    }
                }
            }
        `

        const lancamentoFilter = {
            numeroExtrato: this.filter.numeroExtrato,
            referenciaExtrato: this.filter.referenciaExtrato,
            receitaExtrato: this.filter.receitaExtrato,
            pagoExtrato: this.filter.pagoExtrato
        }

        const nfeFilter = {
            hasLancamento: true,
            revisaoStatus: this.filter.revisaoStatus,
            emissaoInicial: this.filter.emissaoInicial,
            emissaoFinal: this.filter.emissaoFinal,
            numero: this.filter.numero,
            chave: this.filter.chave,
            emitente: this.filter.emitente,
            ...lancamentoFilter
        }

        cbk.deleteEmptyKeys(nfeFilter)

        const variables = { empresaId: this.empresaId, nfeFilter, lancamentoFilter, ...page }
        const { empresa: { nfesPage: { after, before, nfes } } } = await this.gql.query(query, variables)

        const totalLancamentos = (nfe, field) => {
            return nfe.lancamentos.reduce((sum, lancamento) => sum + parseFloat(lancamento[field]), 0)
        }

        this.apply(() => {
            this.nfes = nfes.map(nfe => {
                nfe.totalItens = totalLancamentos(nfe, 'valorTotalItem')
                nfe.totalDebito = totalLancamentos(nfe, 'debito')
                nfe.totalCredito = totalLancamentos(nfe, 'credito')
                nfe.totalIcmsRecolher = totalLancamentos(nfe, 'icmsRecolher')

                return nfe
            })

            this.nextPage = after
            this.previousPage = before
            this.currentPage = this.currentPage + (page.after ? 1 : page.before ? -1 : 0)

            if (!page.after && !page.before)
                this.searchContext = new Date()
        })
    }

    async fetchNfesEmissaoExternaCount() {
        const query = gql`
            query NfesEmissaoExternaCount($empresaId: Int!, $nfeFilter: NfeFilter!) {
                empresa: filial(id: $empresaId) {
                    id
                    nfesCount: nfesCountEmpresa(ferramenta: "auditoria-integrada-icms", filter: $nfeFilter)
                }
            }
        `

        const today = new Date()
        const beginningOfMonth = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30)
        const emissaoInicial = beginningOfMonth.toISOString()

        const variables = { empresaId: this.empresaId, nfeFilter: { emissaoInicial, emissaoExterna: true } }
        const { empresa: { nfesCount } } = await this.gql.query(query, variables)

        this.apply(() => {
            this.nfesEmissaoExternaCount = nfesCount
        })
    }

    createOrReplaceSubscriptions() {
        this.tearDownSubscriptions()

        const variables = { empresaId: this.empresaId }

        const onEvent = ({ data: { nfeRevisada, nfeRevisaoRemovida, nfeComentarioAdicionado } }) => {
            this.nfes = this.nfes.map(nfe => {
                if (nfeRevisada && nfe.id === nfeRevisada.nfe.id) {
                    nfe.revisao = nfeRevisada
                    nfe.revisaoHistorico = nfeRevisada.nfe.revisaoHistorico
                } else if (nfeRevisaoRemovida && nfe.id === nfeRevisaoRemovida.id) {
                    nfe.revisao = null
                    nfe.revisaoHistorico = nfeRevisaoRemovida.revisaoHistorico
                } else if (nfeComentarioAdicionado && nfe.id === nfeComentarioAdicionado.discussao.nfe.id) {
                    nfe.discussao = nfeComentarioAdicionado.discussao
                }

                return nfe
            })
        }

        const nfeRevisadaSubscription = `
            subscription ($empresaId: Int!) {
                nfeRevisada(filialId: $empresaId) {
                    id
                    status
                    insertedAt
                    usuario {
                        id
                        nome
                    }
                    nfe {
                        id
                        ${this.revisaoHistoricoQuery}
                    }
                }
            }
        `
        const nfeRevisaoRemovidaSubscription = `
            subscription ($empresaId: Int!) {
                nfeRevisaoRemovida(filialId: $empresaId) {
                    id
                    ${this.revisaoHistoricoQuery}
                }
            }
        `
        const nfeComentarioAdicionadoSubscription = `
            subscription($empresaId: Int!) {
                nfeComentarioAdicionado(filialId: $empresaId) { 
                    id
                    discussao { 
                        id
                        nfe { id }
                        comentarios {
                            id
                            texto
                            origem
                            insertedAt
                            usuario { nome }
                        }
                    }
                }
            }
        `

        const callback = data => this.apply(() => onEvent(data))

        this.unsubscribers = [
            this.gql.subscribe(nfeRevisadaSubscription, variables, callback),
            this.gql.subscribe(nfeRevisaoRemovidaSubscription, variables, callback),
            this.gql.subscribe(nfeComentarioAdicionadoSubscription, variables, callback)
        ]
    }

    tearDownSubscriptions() {
        if (this.unsubscribers) this.unsubscribers.forEach(unsubscriber => unsubscriber())
    }
}

angular.module('eficienciaFiscalModule')
    .component('lancamentoList', {
        controller: LancamentoList,
        bindings: {
            filter: '<',
            empresaId: '<',
            contratoId: '<'
        },
        //language=HTML
        template: `
        <loading promise="$ctrl.loadingPromise">
            <div style="display: flex; align-items: center; justify-content: space-between; margin: 0 0 9px;">
                <h4>Quantidade de NF-e com origem fora do estado nos últimos 30 dias: 
                    <b class="no-break">{{ $ctrl.nfesEmissaoExternaCount }}</b>
                </h4>
            </div>
            <highlighted ng-show="$ctrl.nfes.length == 0">
                <main>Nenhuma informação encontrada.</main>
            </highlighted>
            <div>
                <cursor-paginator per-page="$ctrl.perPage" next-page="$ctrl.nextPage" previous-page="$ctrl.previousPage"
                    current-page="$ctrl.currentPage" current-page-size="$ctrl.nfes.length" 
                    on-change="$ctrl.pageChange($page)" search-context="$ctrl.searchContext">
                </cursor-paginator>
                <div>
                    <div class="well ng-scope" ng-repeat="nfe in $ctrl.nfes" style="padding: 15px;">
                        <div class="row">
                            <div style="display: flex; flex-direction: row; align-items: center; margin-bottom: 10px;"
                                    class="text-primary">
                                <hr style="margin: 0 10px 0 0;flex-grow: 0; width: 25px">
                                <h5 style="flex-shrink: 1; margin: 0;">NF-e</h5>
                                <hr style="margin: 0 0 0 10px;flex-grow: 1;">
                                <div style="flex-shrink: 1; margin: 0 15px 0 10px; font-size: 18px; line-height: 1em"
                                    ng-if="nfe.revisao">
                                    <i class="fa"
                                        ng-class="$ctrl.getRevisaoIcon(nfe.revisao.status)"
                                        tooltip="{{ $ctrl.getStatusDescricao(nfe.revisao.status) }}">
                                    </i>
                                </div>
                                <span style="flex-shrink: 1; margin: 0 15px 0 0; font-size: 18px; line-height: 1em; color: black;">
                                    {{ (($index + 1) + $ctrl.perPage * ($ctrl.currentPage - 1)).toString().padLeft(3, '0') }}
                                </span>
                            </div>
                            <div style="display: flex; align-items: center;">
                                <div class="col col-md-8 clearfix">
                                    <div class="row">
                                        <div class="col col-sm-3">
                                            <span class="text-bold">Número: </span>
                                            <span>
                                                <span class="ng-binding">{{ nfe.numero }}</span>
                                            </span>
                                        </div>
                                        <div class="col col-sm-3">
                                            <span class="text-bold">Emissão: </span>
                                            <span>
                                                <span class="ng-binding">{{ nfe.emissao | date }}</span>
                                            </span>
                                        </div>
                                        <div class="col col-sm-6">
                                            <span class="text-bold">Razão Social: </span>
                                            <span>
                                                <span class="ng-binding">{{ nfe.emitente.nome }}</span>
                                            </span>
                                        </div>
                                        <div class="col col-sm-3">
                                            <span class="text-bold">Valor: </span>
                                            <span>
                                                <span class="ng-binding">{{ nfe.valor | currency }}</span>
                                            </span>
                                        </div>
                                        <div class="col col-sm-3">
                                            <span class="text-bold">Entrada: </span>
                                            <span>
                                            <span class="ng-binding">{{ nfe.lancamentos[0]["entrada"] | date }}</span>
                                                <i class="fa fa-info-circle text-muted"
                                                    tooltip="Data de entrada da NF-e no portal da SEFIN-RO."></i>
                                            </span>
                                        </div>
                                        <div class="col col-sm-6">
                                            <span class="text-bold">CPF/CNPJ: </span>
                                            <span>
                                                <span class="ng-binding">{{ nfe.emitente.cpfCnpj | cpfCnpj }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col col-md-4">
                                    <div style="display: flex; justify-content: flex-end; flex-flow: wrap">
                                        <button class="btn btn-default" style="margin: 2px"
                                                ng-if="$ctrl.podeEmitirExtratoIcms"
                                                ng-click="$ctrl.emitirExtratoIcms(nfe)">Extrato ICMS
                                        </button>
                                        <button class="btn btn-default" style="margin: 2px"
                                                ng-click="$ctrl.emitirDanfe(nfe)">{{nfe.modelo == 'nfe' ? 'DANFE' : 'DANFCE'}}
                                        </button>
                                        <button class="btn btn-default" style="margin: 2px"
                                                ng-click="$ctrl.iniciarSac(nfe)">SAC
                                        </button>
                                        <div class="btn-group pull-right">
                                            <button class="btn btn-primary ng-scope dropdown-toggle"
                                                    data-toggle="dropdown" style="margin: 2px">
                                                Opções <span class="caret"></span>
                                            </button>
                                            <ul class="dropdown-menu">
                                                <li class="cursor-pointer" 
                                                    ng-repeat="status in $ctrl.statusRevisao"
                                                    ng-hide="status.toLowerCase() == nfe.revisao.status">
                                                    <a href="javascript:void(0)"
                                                        ng-click="$ctrl.revisarNfe(nfe, status)">
                                                        <i class="fa" ng-class="$ctrl.getRevisaoIcon(status.toLowerCase())"></i>
                                                        Marcar como "{{ $ctrl.getStatusDescricao(status.toLowerCase()) }}"
                                                    </a>
                                                </li>
                                                <li class="cursor-pointer">
                                                    <a href="javascript:void(0)" ng-if="nfe.revisao"
                                                        ng-click="$ctrl.removerRevisaoNfe(nfe)">
                                                        <i class="fa fa-times-circle"></i> Marcar como "Não revisada"
                                                    </a>
                                                </li>
                                                <li role="separator" class="divider"></li>
                                                <li class="cursor-pointer">
                                                    <a href="javascript:void(0)" 
                                                        ng-click="$ctrl.exibirHistoricoRevisao(nfe)">
                                                        <i class="fa fa-list-alt"></i> Exibir histórico de revisão
                                                    </a>
                                                </li>
                                                <li class="cursor-pointer">
                                                    <a href="javascript:void(0)" 
                                                        ng-click="$ctrl.exibirComentarios(nfe)">
                                                        <i class="fa fa-comments-o"></i> Exibir comentários
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="row">
                                <div style="display: flex; flex-direction: row; align-items: center; 
                                        margin-top: 10px; margin-bottom: 10px;" class="text-primary">
                                    <hr style="margin: 0 10px 0 0;flex-grow: 0; width: 25px">
                                    <h5 style="flex-shrink: 1; margin: 0;">
                                        LANÇAMENTOS FISCAIS
                                    </h5>
                                    <div style="margin-left: 5px">
                                        <i class="fa fa-info-circle text-muted" tooltip="Informações obtidas no Portal do Contribuinte da Secretaria 
                                            de Finanças do Estado de Rondônia. Para certificação da veracidade 
                                            destas informações, o usuário deverá consultar o mesmo.">
                                        </i>
                                    </div>
                                    <hr style="margin: 0 0 0 10px; flex-grow: 1;">
                                </div>
                                <table class="table table-hover table-condensed" style="margin: 0">
                                    <thead>
                                    <tr>
                                        <th class="text-center" width="1">#</th>
                                        <th class="text-center no-break">Lançamento</th>
                                        <th class="text-center">Receita</th>
                                        <th class="text-center">Frete</th>
                                        <th class="text-right">V. frete</th>
                                        <th class="text-right">Total item</th>
                                        <th class="text-right">% agregado</th>
                                        <th class="text-right">V. agregado</th>
                                        <th class="text-right">Base cálculo</th>
                                        <th class="text-right">Alíq. %</th>
                                        <th class="text-right">Débito</th>
                                        <th class="text-right">Crédito</th>
                                        <th class="text-right">ICMS a recolher</th>
                                        <th class="text-center">Opções</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr ng-repeat="lancamento in nfe.lancamentos" class="ng-scope">
                                        <td class="text-center">{{ $index + 1 }}</td>
                                        <td class="text-center">{{ lancamento.extrato.numero }}</td>
                                        <td class="text-center">{{ lancamento.extrato.receita }}</td>
                                        <td class="text-center">{{ lancamento.freteTipo || '--' }}</td>
                                        <td class="text-right no-break">{{ (lancamento.freteValor | currency) || '--' }} </td>
                                        <td class="text-right no-break">{{ lancamento.valorTotalItem | currency }} </td>
                                        <td class="text-right">{{ lancamento.percentual | currency:'' }} %</td>
                                        <td class="text-right no-break">{{ (lancamento.valorAgregado | currency) || '--' }} </td>
                                        <td class="text-right no-break">{{ lancamento.baseCalculo | currency }} </td>
                                        <td class="text-right no-break">{{ lancamento.aliquota | currency:'' }} % </td>
                                        <td class="text-right no-break">{{ lancamento.debito | currency }}</td>
                                        <td class="text-right no-break">{{ lancamento.credito | currency }}</td>
                                        <td class="text-right no-break">{{ lancamento.icmsRecolher | currency }} </td>
                                        <td class="text-center">
                                            <a href="javascript:void(0)"
                                                ng-click="$ctrl.showDetails(nfe, lancamento)">
                                                <i class="fa fa-search-plus"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    </tbody>
                                    <tfoot>
                                    <tr>
                                        <td></td>
                                        <td colspan="4"></td>
                                        <td class="text-right text-bold">
                                            <i class="fa fa-warning text-warning" 
                                                ng-if="nfe.valor != nfe.totalItens &&
                                                        nfe.lancamentos.length == nfe.lancamentosCount"
                                                tooltip="A totalização dos lançamentos fiscais dos itens é 
                                                        diferente do valor total da NF-e. É importante consultar 
                                                        a Secretaria de Finanças do Estado de Rondônia para 
                                                        verificar a existência de divergências.">
                                            </i>

                                            <i class="fa fa-info-circle" tooltip="Há lançamentos omitidos pelo filtro atual."
                                                ng-if="nfe.valor != nfe.totalItens && 
                                                        nfe.lancamentos.length < nfe.lancamentosCount"></i>
                                            <span class="no-break">{{ nfe.totalItens | currency }}</span>
                                        </td>
                                        <td colspan="4"></td>
                                        <td class="text-right text-bold no-break">{{ nfe.totalDebito | currency}}</td>
                                        <td class="text-right text-bold no-break">{{ nfe.totalCredito | currency}}</td>
                                        <td class="text-right text-bold no-break">{{ nfe.totalIcmsRecolher | currency }}</td>
                                        <td></td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <cursor-paginator per-page="$ctrl.perPage" next-page="$ctrl.nextPage" previous-page="$ctrl.previousPage"
                    current-page="$ctrl.currentPage" current-page-size="$ctrl.nfes.length" 
                    on-change="$ctrl.pageChange($page)" search-context="$ctrl.searchContext">
                </cursor-paginator>
            </div>
        </loading>
        `
    })
